import type { FaireProductEntity } from "../../entity_types/product";

export const p_p3f4vdkkma: FaireProductEntity = {
  token: "p_p3f4vdkkma",
  type: "product",
  name: "Como Tealight Holder / Set of 3 (Ships from Uk)",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/2a830e5467725040ba1ed867e99a5655183c9b44bcd4148f2a1352aa23a9701f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe38b9a4fa88be50e82ce04f9b1b365de12e7f6bb6f39ab6948b2f00a229f494.jpeg",
    "https://cdn.faire.com/fastly/31e8e009075b19bea7683c0303365d151a8e98710d121d05933745e60a2ced73.jpeg",
    "https://cdn.faire.com/fastly/a953469b9da756f703a7e7a8f05db4a543d38868a9206e799d29c2198b2b9aaf.jpeg",
  ],
  priceDollars: 20.16,
  description:
    "PLEASE NOTE THAT THIS ITEM WILL BE SHIPPING FROM OUR UK WAREHOUSE\n\nCOMO tealight holders are an elegant, easy way to add rich materiality to your home. Place them around the room or cluster them in one area to bring warmth and a subtle glow to your interior. Each COMO tealight holder is handcrafted from a solid piece of beautiful marble with a sophisticated matte honed finish.\n\nProduct information\n\nPlease note that due to the nature of the material, colour and pattern variation will occur. Giving you a truly unique piece. Our photos should be used as a guide.\n\nDimensions: H35 x D55mm\nMaterial: Marble",
  tags: [],
  msrpDollars: 48,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:18.363Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
